import { Mail, MapPin, Phone } from "lucide-react";
import { useSiteContent } from "../../lib/content";
import { emailHref, navItems, phoneHref } from "../../lib/siteContent";
import { Container } from "../ui/Container";

export function Footer() {
  const year = new Date().getFullYear();
  const { content } = useSiteContent();
  const { name, phone, email, zone } = content.contact;

  return (
    <footer className="border-t bg-surface/60 py-12">
      <Container className="grid gap-10 sm:grid-cols-3">
        <div>
          <p className="font-heading text-lg font-semibold text-primary">{name}</p>
          <p className="mt-2 text-sm text-muted">Reparação e manutenção de computadores.</p>
        </div>
        <nav aria-label="Links rápidos">
          <p className="mb-3 font-heading text-sm font-semibold text-primary">Navegação</p>
          <ul className="space-y-2 text-sm text-muted">
            {navItems.map((item) => (
              <li key={item.href}>
                <a href={item.href} className="hover:text-primary">
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="mb-3 font-heading text-sm font-semibold text-primary">Contactos</p>
          <ul className="space-y-2 text-sm text-muted">
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-primary" aria-hidden />
              <a href={phoneHref(phone)}>{phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-primary" aria-hidden />
              <a href={emailHref(email)}>{email}</a>
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-primary" aria-hidden />
              {zone}
            </li>
          </ul>
        </div>
      </Container>
      <Container className="mt-10 border-t pt-6 text-xs text-muted">
        © {year} {name} · {zone}
      </Container>
    </footer>
  );
}
